import { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { format } from 'date-fns';

const DatePickerComponent = ({ onDateRangeChange, type }) => {
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;

  const handleDateChange = (update) => {

    console.log('---Selected date range:', update);
    const [newStartDate, newEndDate] = update;
    setDateRange(update);

    if (newStartDate) {
      if (type === "WeddingDate") {
        const formattedStart = newStartDate ? format(newStartDate, 'yyyy-MM-dd') : null;
        const formattedEnd = newEndDate ? format(newEndDate, 'yyyy-MM-dd') : null;
        onDateRangeChange({
          from: formattedStart,
          to: formattedEnd,
        });
      } else if (type === "CreateDate" || type === 'eventDate') {
        const formattedStart = newStartDate ? format(newStartDate, 'yyyy-MM-dd') : null;
        const formattedEnd = newEndDate ? format(newEndDate, 'yyyy-MM-dd') : null;
        onDateRangeChange({
          startDate: formattedStart,
          endDate: formattedEnd,
        });
      }
    } else {
      onDateRangeChange(null);
    }
  };


  return (
    <div className="custom-date-picker">
      <DatePicker
        selectsRange
        // showMonthYearPicker
        showMonthDropdown
        showYearDropdown
        scrollableYearDropdown
        startDate={startDate}
        endDate={endDate}
        onChange={handleDateChange}
        className="form-control"
        placeholderText={type === "WeddingDate" ? "Wedding Date Filter" : type === 'eventDate' ? "Event Date Filter" : "Created Date Filter"}
        isClearable
        dateFormat="dd/MM/yyyy"
        onKeyDown={(e) => e.preventDefault()}
      />
    </div>
  );
};

export default DatePickerComponent;